import Header from '@scripts/partials/header'
import Home from '@scripts/partials/home'
import Actu from '@scripts/partials/actu'
import initAppearAnim from '@scripts/utils/appear-anim'
import Video from '@scripts/partials/video'
import Selectbox from '@scripts/components/selectbox'
import initExpands from '@scripts/components/expands.js'
import Documents from '@scripts/blocks/documents'
import Modals from '@scripts/blocks/modals'
import Breadcrumbs from '../blocks/breadcrumbs.js'
import Tabs from '../partials/tabs.js'
import initListeMembreAvatar from '../blocks/liste-membre-avatar.js'
import initListeMembreContact from '../blocks/liste-membre-contact.js'
import initChiffres from '../blocks/chiffres.js'
import initBenefits from '../blocks/benefits.js'
import initActualites from '../blocks/actualites.js'
import initVideoCarousel from '../blocks/video-carousel.js'
import initEntreprises from '../blocks/entreprises.js'
import contact7 from '../components/contact7.js'
import Dropdown from '../components/dropdown.js'
import HeaderSearch from '../partials/header-search.js'
import Identification from '../partials/identification.js'
import Recherche from '../blocks/recherche.js'
import DocumentPartager from '../partials/document-partage.js'
import Adhesion from '../partials/adhesion.js'
import Entete from '../partials/entete.js'
import Contact from '../partials/contact.js'
import initInputClear from '../components/input-clear.js'
import favoris from '../components/favoris-handler.js'
import adherent from '../components/adherent-handler.js'
import Faq from '../partials/faq.js'
import Account from '../partials/account.js'
import Notifications from '../partials/notifications.js'
import BandNews from '../partials/band-news.js'
import Events from '../blocks/events.js'

export default {
  header: null,
  suggestionSwipers: ['.swiper-search', '.convention-header-suggestions'],
  init () {
    this.preventDefaultForAllHashLInk()
    this.header = new Header()
    this.home = new Home()
    this.selectbox = new Selectbox()
    this.documents = new Documents()
    this.modals = new Modals()
    this.video = new Video()
    this.breadcrumbs = new Breadcrumbs()
    this.tabs = new Tabs()
    this.actu = new Actu()
    this.headerSearch = new HeaderSearch()
    this.recherche = new Recherche()
    this.actu.init()
    this.dropdown = new Dropdown()
    this.dropdown.init()
    this.identification = new Identification()
    this.identification.init()
    this.documentpargager = new DocumentPartager()
    this.documentpargager.init()
    this.adhesion = new Adhesion()
    this.adhesion.init()
    this.entete = new Entete()
    this.entete.init()
    this.contact = new Contact()
    this.contact.init()
    this.faq = new Faq()
    this.faq.init()
    this.account = new Account()
    this.account.init()
    this.bandnews = new BandNews()
    this.bandnews.init()
    this.events = new Events()
    this.events.init()
    initAppearAnim()
    initExpands()
    initListeMembreAvatar()
    initListeMembreContact()
    initChiffres()
    initBenefits()
    initActualites()
    initVideoCarousel()
    initEntreprises()
    initInputClear()
    favoris.init()
    Notifications.init()
    contact7()
    adherent.init()
  },

  preventDefaultForAllHashLInk () {
    $(document).on('click', 'a[href=\'#\']', function (event) {
      event.preventDefault()
    })
  },

  initSuggestionSwiper () {
    this.suggestionSwipers.forEach((swiperSelector) => {
      document.querySelectorAll(swiperSelector).forEach((swiper) => {
        console.log(swiper.swiper)

        if (swiper.swiper.initialized) {
          swiper.style.display = 'flex'
        } else {
          swiper.swiper.on('init', () => {
            swiper.style.display = 'flex'
          })
        }
      })
    })
  },

  finalize () {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // this.header.calculMaxHeight()
    this.initSuggestionSwiper()
  }
}
